export function UnreadBadge({ count, label }: { count: number; label?: string }) {
  if (count <= 0) return null

  return (
    <span
      className="inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-primary text-[0.6875rem] font-semibold text-primary-foreground"
      aria-label={
        label ?? `${count} ungelesene ${count === 1 ? 'Änderung' : 'Änderungen'}`
      }
      data-numeric
    >
      {count > 9 ? '9+' : count}
    </span>
  )
}
